import { render } from "./week-row-header.vue?vue&type=template&id=20416d77&ts=true"
import script from "./week-row-header.vue?vue&type=script&lang=ts"
export * from "./week-row-header.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__